import { format } from 'date-fns';
import classNames from 'classnames';
import styles from './home.module.css'
import useTranslatedHeaders from "../../utils/constants/useTranslatedHeaders";
import { Footer, HomeHero, ForecastTable, Title, HourlyCast } from '../../components';
import { useLanguage } from "../../components/contexts/LanguageContext";
import translations from '../../components/translations';
import { useEffect, useState } from 'react';
import { useGetDefaultOU } from '../../hooks/orgunits/useGetDefaultOU';
import { useParams } from '../../hooks/common/useParams';
import { useGetData } from '../../hooks/getData/useGetData';
import { ClimateDataType } from '../../types/climateData/ClimateDataTypes';
import Loader from '../../components/loader/Loader';
import { useLocation } from 'react-router-dom';


function Home() {
  const { getData } = useGetData()
  const { selectedLanguage } = useLanguage();
  const { loading, ous } = useGetDefaultOU();
  const { add, useUrlParamiters } = useParams()
  const { tableheaders } = useTranslatedHeaders();
  const [data, setData] = useState<ClimateDataType[]>()
  const [gettingData, setGettingData] = useState<boolean>(false)
  const { orgUnit, orgUnitName, parentId } = useUrlParamiters()

  // const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setSelectedLanguage(e.target.value as 'pt' | 'en');
  // };

  useEffect(() => {
    const fetchData = async () => {
      const today = format(new Date(), "yyyyMMdd");
      setGettingData(true);
      try {
        const orgUnitsData = await getData(`organisationUnits/station/?parentUnitId=${parentId}`);
        const auxData: any[] = [];

        if (orgUnitsData?.organizationUnits?.length) {
          const promises = orgUnitsData.organizationUnits.map(async (orgUnit: any) => {
            const climateData = await getData(`climateData/future?periodType=DAILY_RANGE&startDate=${today}&endDate=${today}&organisationUnitId=${orgUnit?.id}`);
            return climateData?.climateData?.[0];
          });

          const results = await Promise.all(promises);
          auxData.push(...results.filter(Boolean));
        }

        setData(auxData as unknown as ClimateDataType[]);
      } catch (error) {
      } finally {
        setGettingData(false);
      }
    };

    if (parentId) {
      void fetchData();
    }
  }, [orgUnit]);


  useEffect(() => {
    if (ous?.defaultOu && !orgUnit && !orgUnitName && !parentId) {
      add("orgUnit", ous.defaultOu.id);
      add("orgUnitName", ous.defaultOu.name);
      add("parentId", ous.defaultOu.parent?.id);
    }
  }, [ous]);

  if (loading) {
    return (
      <Loader />
    )
  }

  return (
    <div className={styles.homeContainer}>
      <HomeHero />

      <main className={classNames(styles.layout, "container")}>
        <HourlyCast />

        <section>
          <Title label={`${translations[selectedLanguage].weatherForecast}  - ${format(new Date(), "dd MMM yyyy")}`} />
          <ForecastTable loading={gettingData} headers={tableheaders} rows={data as unknown as ClimateDataType[]} />
        </section>

      </main>

      <Footer />
    </div>
  );
}

export { Home };